import React, { useCallback, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  SelectFBProfileData,
  facebookAdsDataPull,
  SelectFBAccessToken,
  SelectFBAdsAccountData,
  SelectFBAdsActiveAccount,
  facebookAdDetailRetrieve,
  selectedFBAdData,
  updateadsAccountData,
  graphFBAdsAccount,
  graphFBAdsClientAccount,
} from "./FacebookAdsSlice";
import ViewAdsDetails from "./ViewAdsDetails";
import MultiSearchValue from "./MultiSearchValue";
import { selectLogInUsername } from "../../../../common/authenticateDashboard/authSlice";
import DynamicMultiSelect from "./DynamicMultiSelect";
import SingleDropdown from "./Dropdown";

const FacebookAds = () => {
  const dispatch = useDispatch();
  const facebookProfiledData = useSelector((state) => state.facebook);
  console.log("facebookProfiledData", facebookProfiledData);
  const userFBProfileData = useSelector(SelectFBProfileData);
  const liveFBAdsActiveAccount = useSelector(SelectFBAdsActiveAccount);
  const userselectedFBAdData = useSelector(selectedFBAdData);
  //   console.log("userFBProfileData", userFBProfileData);
  const fb_ads_account_data = useSelector(SelectFBAdsAccountData);
  let FB_AdData = fb_ads_account_data || [];
  console.log("fb_ads_account_data", fb_ads_account_data);
  let fb_accessToken = useSelector(SelectFBAccessToken);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [maxDate, setMaxDate] = useState("");
  const [open, setOpen] = useState(false);

  const ageDropdownRef = useRef(null);
  const genderDropdownRef = useRef(null);
  const countryDropdownRef = useRef(null);
  const campaignDropdownRef = useRef(null);
  const adNameDropdownRef = useRef(null);

  const [showAgeDropdown, setShowAgeDropdown] = useState(false);
  const [showGenderDropdown, setShowGenderDropdown] = useState(false);
  const [showCountryDropdown, setShowCountryDropdown] = useState(false);
  const [showCampaignDropdown, setShowCampaignDropdown] = useState(false);
  const [showAdNameDropdown, setShowAdNameDropdown] = useState(false);

  const [selectedAges, setSelectedAges] = useState([]);
  const [uniqueAges, setUniqueAges] = useState([]);

  const [selectedGenders, setSelectedGenders] = useState([]);
  const [uniqueGenders, setUniqueGenders] = useState([]);

  const [selectedCountries, setSelectedCountries] = useState([]);
  const [uniqueCountries, setUniqueCountries] = useState([]);

  const [selectedCampaignNames, setSelectedCampaignNames] = useState([]);
  const [uniqueCampaignNames, setUniqueCampaignNames] = useState([]);

  const [selectedAdNames, setSelectedAdNames] = useState([]);
  const [uniqueAdNames, setUniqueAdNames] = useState([]);

  const sessionUser = useSelector(selectLogInUsername);
  const user = sessionUser?.split("@")[0];

  const [activeSortField, setActiveSortField] = useState(null);
  const [activeSortOrder, setActiveSortOrder] = useState(null);


  //   const [availableAges, setAvailableAges] = useState([]);
  // const [availableGenders, setAvailableGenders] = useState([]);

  // // Populate available options initially
  // useEffect(() => {
  //   setAvailableAges(uniqueAges.filter(age => !selectedAges.includes(age)));
  //   setAvailableGenders(uniqueGenders.filter(gender => !selectedGenders.includes(gender)));
  // }, [uniqueAges, uniqueGenders, selectedAges, selectedGenders]);

  useEffect(() => {
    let d = new Date();
    let day = d.getDate();
    let month = d.getMonth(); // Month is zero-based
    let year = d.getFullYear();

    // Calculate the start date (one month ago)
    let prevMonth = month === 0 ? 11 : month - 1;
    let prevYear = month === 0 ? year - 1 : year;
    let start_date = `${prevYear}-${(prevMonth + 1)
      .toString()
      .padStart(2, "0")}-${day.toString().padStart(2, "0")}`;

    // Format the end date (today)
    let end_date = `${year}-${(month + 1).toString().padStart(2, "0")}-${day
      .toString()
      .padStart(2, "0")}`;

    // Set the formatted dates
    setStartDate(start_date);
    setEndDate(end_date);
    setMaxDate(end_date);
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        ageDropdownRef.current &&
        !ageDropdownRef.current.contains(event.target)
      ) {
        setShowAgeDropdown(false);
      }
      if (
        genderDropdownRef.current &&
        !genderDropdownRef.current.contains(event.target)
      ) {
        setShowGenderDropdown(false);
      }
      if (
        countryDropdownRef.current &&
        !countryDropdownRef.current.contains(event.target)
      ) {
        setShowCountryDropdown(false);
      }
      if (
        campaignDropdownRef.current &&
        !campaignDropdownRef.current.contains(event.target)
      ) {
        setShowCampaignDropdown(false);
      }

      if (
        adNameDropdownRef.current &&
        !adNameDropdownRef.current.contains(event.target)
      ) {
        setShowAdNameDropdown(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    console.log("FB_AdData: ", FB_AdData);
    if (FB_AdData && FB_AdData.length > 0) {
      const extractUnique = (key) =>
        FB_AdData.map((ad) => ad[key]).filter(
          (value, index, self) => value && self.indexOf(value) === index
        );

      setUniqueAges(extractUnique("age"));
      setUniqueGenders(extractUnique("gender"));
      setUniqueCountries(extractUnique("country"));
      setUniqueCampaignNames(extractUnique("campaign_name"));
      setUniqueAdNames(extractUnique("ad_name"));
    }
  }, [FB_AdData]);

  const toggleAgeDropdown = () => setShowAgeDropdown(!showAgeDropdown);
  const toggleCountryDropdown = () =>
    setShowCountryDropdown(!showCountryDropdown);
  const toggleCampaignDropdown = () =>
    setShowCampaignDropdown(!showCampaignDropdown);
  const toggleAdNameDropdown = () => setShowAdNameDropdown(!showAdNameDropdown);

  const viewAdsHandler = (adsAccountId) => {
    // dispatch(graphFBAdsClientAccount({ user, id: adsAccountId }));
    dispatch(
      facebookAdsDataPull({
        id: adsAccountId,
        accessToken: fb_accessToken,
        start_date: startDate,
        end_date: endDate,
        breakdowns: "age,gender",
      })
    );
  };

  const viewAdsDetails = (ad_id) => {
    dispatch(
      facebookAdDetailRetrieve({
        id: ad_id,
        accessToken: fb_accessToken,
      })
    );
    setOpen(true);
  };

  const filterData = () => {
    return FB_AdData.filter((ad) => {
      return (
        (selectedAges.length === 0 || selectedAges.includes(ad.age)) &&
        (selectedGenders.length === 0 || selectedGenders.includes(ad.gender)) &&
        (selectedCountries.length === 0 || selectedCountries.includes(ad.country)) &&
        (selectedCampaignNames.length === 0 || selectedCampaignNames.includes(ad.campaign_name)) &&
        (selectedAdNames.length === 0 || selectedAdNames.includes(ad.ad_name))
      );
    });
  };
  const search_Fb_adData = () => {
    let date1 = new Date(startDate);
    let date2 = new Date(endDate);
    var diff = date1.valueOf() - date2.valueOf();
    if (diff > 0) {
      console.log("Invalid Date Selection");
    } else {
      console.log("calling viewAdsHandler()...");
      viewAdsHandler(liveFBAdsActiveAccount);
    }
  };

  const sort_adData = useCallback(
    function sort_adData(fieldName, order) {
      if (!Array.isArray(FB_AdData) || FB_AdData.length === 0) {
        console.error("FB_AdData is not an array, is empty, or not iterable.");
        return;
      }

      const sortedFB_AdData = [...FB_AdData].sort((a, b) => {
        const valA = a[fieldName] ? a[fieldName].toString() : "";
        const valB = b[fieldName] ? b[fieldName].toString() : "";

        if (order === "incr") {
          return valA.localeCompare(valB);
        } else {
          return valB.localeCompare(valA);
        }
      });
      setActiveSortField(fieldName);
      setActiveSortOrder(order);
      dispatch(updateadsAccountData(sortedFB_AdData));
    },
    [FB_AdData, dispatch]
  );

  return (
    <>
      {Object.keys(userFBProfileData).length ? (
        <div className="border-[1.5px] border-cyan-700 p-4 shadow-lg rounded-md relative">
          <h2 className="text-lg font-bold text-gray-700 mb-4">
            Facebook Account Details
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
            <div className="grid place-content-center border rounded-md py-3 px-1 text-lg ">
              <img
                src={userFBProfileData?.profile_pic}
                alt="profile pic"
                className="rounded-full w-[120px] m-auto border-2 my-3"
              />
              <p>
                Name :{" "}
                <span className="font-semibold">{userFBProfileData?.name}</span>
              </p>
              <p>
                Email :{" "}
                <span className="font-semibold">
                  {userFBProfileData?.email}
                </span>
              </p>
              <p>
                User_Id :
                <span className="font-semibold">
                  {userFBProfileData?.userID}
                </span>
              </p>
            </div>
            <div className="overflow-auto">
              <h2 className="text-lg mb-3 font-semibold text-gray-700">
                Ads Account Details
              </h2>
              <table className="border-[1.5px] border-gray-500 overflow-auto rounded-lg">
                <thead>
                  <tr>
                    <th className="p-2 border-[1.5px] border-gray-500">
                      Account Name
                    </th>
                    <th className="p-2 border-[1.5px] border-gray-500">
                      Account Id
                    </th>
                    <th className="p-2 border-[1.5px] border-gray-500">
                      Ads Detail
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {userFBProfileData?.ads_accounts?.map(({ name, id }) => (
                    <tr key={id}>
                      <td className="p-2 border-[1.5px] border-gray-500">
                        {name}
                      </td>
                      <td className="p-2 border-[1.5px] border-gray-500">
                        {id}
                      </td>
                      <td className="p-2 border-[1.5px] border-gray-500 m-auto">
                        <button
                          onClick={() => {
                            viewAdsHandler(id);
                          }}
                          className="border-2 border-indigo-500 text-sm text-indigo-500 p-1 px-2 rounded-md hover:bg-indigo-500 hover:text-white block mx-auto"
                        >
                          {" "}
                          View{" "}
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>

          {open && userselectedFBAdData && (
            <ViewAdsDetails open={open} setOpen={setOpen} />
          )}

          {liveFBAdsActiveAccount && (
            <>
              <div className="flex gap-5 items-center border-2 py-3 px-2.5 rounded-sm mt-3 md:mt-5">
                <div className="flex items-center gap-5">
                  <div className="flex flex-col gap-1">
                    <label htmlFor="start_date">Start Date:</label>
                    <input
                      type="date"
                      value={startDate}
                      onChange={(e) => setStartDate(e.target.value)}
                      id="start_date"
                      name="start_date"
                      placeholder="yyyy-mm-dd"
                      max={maxDate}
                      className="rounded-md"
                    />
                  </div>
                  <div className="flex flex-col gap-1">
                    <label htmlFor="end_date">End Date:</label>
                    <input
                      type="date"
                      value={endDate}
                      onChange={(e) => setEndDate(e.target.value)}
                      id="end_date"
                      name="end_date"
                      placeholder="yyyy-mm-dd"
                      max={maxDate}
                      className="rounded-md"
                    />
                  </div>
                </div>

                <div className="ms-auto flex flex-col items-center justify-center  gap-1">
                  <button
                    type="button"
                    className="flex items-center justify-center gap-2 rounded-md border-2 bg-indigo-600 text-white py-2 px-4 hover:opacity-9"
                    onClick={() => search_Fb_adData()}
                  >
                    Search
                  </button>
                </div>
              </div>
              <div className="my-5 border-2 rounded-md p-3 flex gap-5 flex-wrap">
                <div ref={ageDropdownRef} className="relative">
                    <DynamicMultiSelect
                      initialOptions={uniqueAges}
                      selectedOptions={selectedAges}
                      setSelectedOptions={setSelectedAges}
                      name = "Age"
                    />
                  
                </div>
                <div ref={genderDropdownRef} className="relative">
                <DynamicMultiSelect
                      initialOptions={uniqueGenders}
                      selectedOptions={selectedGenders}
                      setSelectedOptions={setSelectedGenders}
                      name="Gender"
                    />
                </div>

                <div className="relative" ref={countryDropdownRef}>
                  <input
                    type="text"
                    onFocus={toggleCountryDropdown}
                    value={selectedCountries.join(", ")}
                    placeholder="Country"
                    readOnly
                    className="rounded-md"
                  />
                  {showCountryDropdown && (
                    <SingleDropdown
                      options={uniqueCountries}
                      selectedOptions={selectedCountries}
                      onChange={setSelectedCountries}
                    />
                  )}
                </div>

                <div ref={campaignDropdownRef} className="relative">
                  <SingleDropdown
                    options={uniqueCampaignNames}
                    selectedOption={selectedCampaignNames}
                    onChange={setSelectedCampaignNames}
                    name="Campaign Name"
                  />
                </div>

                <div ref={adNameDropdownRef} className="relative">
                  <SingleDropdown
                    options={uniqueAdNames}
                    selectedOption={selectedAdNames}
                    onChange={setSelectedAdNames}
                    name="Ad Name"
                  />
                </div>
              </div>
            </>
          )}

          {FB_AdData?.length && (
            <>
              <div className="my-5 overflow-auto border-t-2 py-4">
                <h2 className="text-lg mb-2">
                  Ad Account Id:{" "}
                  <span className="font-bold text-teal-600">
                    {liveFBAdsActiveAccount}
                  </span>
                </h2>
                <div className="overflow-y-scroll h-[700px]">
                <table className="border-[1.5px] border-gray-500 overflow-auto">
                  <thead>
                    <tr>
                      <th className="p-2 border-[1.5px] border-gray-500">
                        <div className="flex justify-between items-center gap-2">
                          <p>age</p>
                          <SortCustomFunction
                            cbfn={sort_adData}
                            labelText="age"
                            activeSortField={activeSortField}
                            activeSortOrder={activeSortOrder}
                          />
                        </div>
                      </th>
                      <th className="p-2 border-[1.5px] border-gray-500">
                        <div className="flex justify-between items-center gap-2">
                          <p>gender</p>
                          <SortCustomFunction
                            cbfn={sort_adData}
                            labelText="gender"
                            activeSortField={activeSortField}
                            activeSortOrder={activeSortOrder}
                          />
                        </div>
                      </th>
                      <th className="p-2 border-[1.5px] border-gray-500">
                        <div className="flex justify-between items-center gap-2">
                          <p>campaign id</p>
                          <SortCustomFunction
                            cbfn={sort_adData}
                            labelText="campaign_id"
                            activeSortField={activeSortField}
                            activeSortOrder={activeSortOrder}
                          />
                        </div>
                      </th>
                      <th className="p-2 border-[1.5px] border-gray-500">
                        <div className="flex justify-between items-center gap-2">
                          <p>campaign name</p>
                          <SortCustomFunction
                            cbfn={sort_adData}
                            labelText="campaign_name"
                            activeSortField={activeSortField}
                            activeSortOrder={activeSortOrder}
                          />
                        </div>
                      </th>
                      <th className="p-2 border-[1.5px] border-gray-500">
                        <div className="flex justify-between items-center gap-2">
                          <p>adset id</p>
                          <SortCustomFunction
                            cbfn={sort_adData}
                            labelText="adset_id"
                            activeSortField={activeSortField}
                            activeSortOrder={activeSortOrder}
                          />
                        </div>
                      </th>
                      <th className="p-2 border-[1.5px] border-gray-500">
                        <div className="flex justify-between items-center gap-2">
                          <p>adset name</p>
                          <SortCustomFunction
                            cbfn={sort_adData}
                            labelText="adset_name"
                            activeSortField={activeSortField}
                            activeSortOrder={activeSortOrder}
                          />
                        </div>
                      </th>
                      <th className="p-2 border-[1.5px] border-gray-500">
                        <div className="flex justify-between items-center gap-2">
                          <p>ad id</p>
                          <SortCustomFunction
                            cbfn={sort_adData}
                            labelText="ad_id"
                            activeSortField={activeSortField}
                            activeSortOrder={activeSortOrder}
                          />
                        </div>
                      </th>
                      <th className="p-2 border-[1.5px] border-gray-500">
                        <div className="flex justify-between items-center gap-2">
                          <p>ad name</p>
                          <SortCustomFunction
                            cbfn={sort_adData}
                            labelText="ad_name"
                            activeSortField={activeSortField}
                            activeSortOrder={activeSortOrder}
                          />
                        </div>
                      </th>
                      <th className="p-2 border-[1.5px] border-gray-500">
                        <div className="flex justify-between items-center gap-2">
                          <p>spend</p>
                          <SortCustomFunction
                            cbfn={sort_adData}
                            labelText="spend"
                            activeSortField={activeSortField}
                            activeSortOrder={activeSortOrder}
                          />
                        </div>
                      </th>
                      <th className="p-2 border-[1.5px] border-gray-500">
                        <div className="flex justify-between items-center gap-2">
                          <p>impressions</p>
                          <SortCustomFunction
                            cbfn={sort_adData}
                            labelText="impressions"
                            activeSortField={activeSortField}
                            activeSortOrder={activeSortOrder}
                          />
                        </div>
                      </th>
                      <th className="p-2 border-[1.5px] border-gray-500">
                        <div className="flex justify-between items-center gap-2">
                          <p>clicks</p>
                          <SortCustomFunction
                            cbfn={sort_adData}
                            labelText="clicks"
                            activeSortField={activeSortField}
                            activeSortOrder={activeSortOrder}
                          />
                        </div>
                      </th>
                      <th className="p-2 border-[1.5px] border-gray-500">
                        <div className="flex justify-between items-center gap-2">
                          <p>reach</p>
                          <SortCustomFunction
                            cbfn={sort_adData}
                            labelText="reach"
                            activeSortField={activeSortField}
                            activeSortOrder={activeSortOrder}
                          />
                        </div>
                      </th>
                      <th className="p-2 border-[1.5px] border-gray-500">
                        <div className="flex justify-between items-center gap-2">
                          <p>frequency</p>
                          <SortCustomFunction
                            cbfn={sort_adData}
                            labelText="frequency"
                            activeSortField={activeSortField}
                            activeSortOrder={activeSortOrder}
                          />
                        </div>
                      </th>
                      <th className="p-2 border-[1.5px] border-gray-500">
                        <div className="flex justify-between items-center gap-2">
                          <p>ctr</p>
                          <SortCustomFunction
                            cbfn={sort_adData}
                            labelText="ctr"
                            activeSortField={activeSortField}
                            activeSortOrder={activeSortOrder}
                          />
                        </div>
                      </th>
                      <th className="p-2 border-[1.5px] border-gray-500">
                        <div className="flex justify-between items-center gap-2">
                          <p>cpm</p>
                          <SortCustomFunction
                            cbfn={sort_adData}
                            labelText="cpm"
                            activeSortField={activeSortField}
                            activeSortOrder={activeSortOrder}
                          />
                        </div>
                      </th>
                      <th className="p-2 border-[1.5px] border-gray-500">
                        <div className="flex justify-between items-center gap-2">
                          <p>cpc</p>
                          <SortCustomFunction
                            cbfn={sort_adData}
                            labelText="cpc"
                            activeSortField={activeSortField}
                            activeSortOrder={activeSortOrder}
                          />
                        </div>
                      </th>
                      <th className="p-2 border-[1.5px] border-gray-500">
                        <div className="flex justify-between items-center gap-2">
                          <p>Ad Details</p>
                        </div>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {/* {fb_ads_account_data?.map((item) => ( */}
                    {FB_AdData?.map((item) => (
                      <tr>
                        <td className="p-2 border-[1.5px] border-gray-500 min-w-[80px]">
                          {item.age}
                        </td>
                        <td className="p-2 border-[1.5px] border-gray-500">
                          {item.gender}
                        </td>
                        <td className="p-2 border-[1.5px] border-gray-500">
                          {item.campaign_id}
                        </td>
                        <td className="p-2 border-[1.5px] border-gray-500">
                          {item.campaign_name}
                        </td>
                        <td className="p-2 border-[1.5px] border-gray-500">
                          {item.adset_id}
                        </td>
                        <td className="p-2 border-[1.5px] border-gray-500">
                          {item.adset_name}
                        </td>
                        <td className="p-2 border-[1.5px] border-gray-500">
                          {item.ad_id}
                        </td>
                        <td className="p-2 border-[1.5px] border-gray-500">
                          {item.ad_name}
                        </td>
                        <td className="p-2 border-[1.5px] border-gray-500">
                          {item.spend}
                        </td>
                        <td className="p-2 border-[1.5px] border-gray-500">
                          {item.impressions}
                        </td>
                        <td className="p-2 border-[1.5px] border-gray-500">
                          {item.clicks}
                        </td>
                        <td className="p-2 border-[1.5px] border-gray-500">
                          {item.reach}
                        </td>
                        <td className="p-2 border-[1.5px] border-gray-500">
                          {item.frequency}
                        </td>
                        <td className="p-2 border-[1.5px] border-gray-500">
                          {item.ctr}
                        </td>
                        <td className="p-2 border-[1.5px] border-gray-500">
                          {item.cpm}
                        </td>
                        <td className="p-2 border-[1.5px] border-gray-500">
                          {item.cpc}
                        </td>
                        <td className="p-2 border-[1.5px] border-gray-500">
                          <button
                            className="bg-teal-600 p-2 rounded-md block mx-auto text-white "
                            onClick={() => viewAdsDetails(item.ad_id)}
                          >
                            view{" "}
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                </div>
              </div>
            </>
          )}
        </div>
      ) : null}
    </>
  );
};

export default FacebookAds;

const SortCustomFunction = ({
  cbfn,
  labelText,
  activeSortField,
  activeSortOrder,
}) => {
  return (
    <div className="flex flex-col">
      {activeSortField === labelText && activeSortOrder === "incr" ? (
        <span
          className="text-sm hover:cursor-pointer"
          onClick={() => cbfn(labelText, "decr")}
        >
          &#9660;
        </span>
      ) : (
        <span
          className="text-sm hover:cursor-pointer"
          onClick={() => cbfn(labelText, "incr")}
        >
          &#9650;
        </span>
      )}
    </div>
  );
};
